import type { ModelView } from "../shared/contracts.ts";

/** Collapses repeated component URLs while retaining distinct cache/launch evidence. */
export function originalEvidenceLinks(model: ModelView): Array<{ url: string; label: string }> {
  const labels = new Map<string, Set<string>>();
  for (const source of model.originalSources ?? []) {
    const entries = labels.get(source.sourceUrl) ?? new Set<string>();
    entries.add(source.component === "cache-read" ? "cache" : source.component);
    labels.set(source.sourceUrl, entries);
  }
  for (const source of model.originalStatusEvidence ?? []) {
    if (!source.sourceUrl) continue;
    const entries = labels.get(source.sourceUrl) ?? new Set<string>();
    entries.add("status");
    labels.set(source.sourceUrl, entries);
  }
  return [...labels].map(([url, components]) => ({ url, label: `${[...components].join("/")} evidence` }));
}
